import { render } from "./OurStory.vue?vue&type=template&id=fa786afa&scoped=true"
import script from "./OurStory.vue?vue&type=script&lang=js"
export * from "./OurStory.vue?vue&type=script&lang=js"

import "./OurStory.vue?vue&type=style&index=0&id=fa786afa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fa786afa"

export default script